// step11.js - Service Complaints (FINAL CORRECTED - matches template exactly)
import React from 'react';
import ModernDataTable from '../ui/ModernDataTable';

const Step11 = ({ serviceComplaintItems, setServiceComplaintItems, defaultDateTime }) => {
  const complaintFields = [
    {
      name: 'complaintTime', // ← CRITICAL: Was 'complaintDateTime' - now matches template
      type: 'datetime',
      label: 'Complaint Date/Time Received',
      header: 'Complaint Time',
      required: true,
      validationMessage: 'Please enter when the service complaint was received',
      hint: 'Record the exact date and time when the service complaint was first received or reported to staff.'
    },
    {
      name: 'complaintCategory',
      type: 'dropdown',
      label: 'Complaint Category',
      header: 'Category',
      placeholder: 'Select the type of service complaint',
      options: [
        { value: 'Food/Beverage Quality', label: 'Food/Beverage Quality' },
        { value: 'Staff Behavior/Attitude', label: 'Staff Behavior/Attitude' },
        { value: 'Wait Times/Delays', label: 'Wait Times/Delays' },
        { value: 'Facility/Cleanliness Issues', label: 'Facility/Cleanliness Issues' },
        { value: 'Pricing/Billing Concerns', label: 'Pricing/Billing Concerns' },
        { value: 'Accessibility/Special Needs', label: 'Accessibility/Special Needs' },
        { value: 'Communication/Information', label: 'Communication/Information' },
        { value: 'Safety/Security Concerns', label: 'Safety/Security Concerns' },
        { value: 'Other Service Issue', label: 'Other Service Issue' }
      ],
      required: true,
      validationMessage: 'Please select the category of service complaint',
      hint: 'Choose the category that best describes the nature of the service complaint received.'
    },
    {
      name: 'customComplaintCategory', // ← ADDED: Required by template
      type: 'text',
      label: 'Custom Complaint Category',
      header: 'Custom Category',
      placeholder: 'Specify custom complaint type if "Other Service Issue" selected',
      hideUntil: {
        condition: (data) => data.complaintCategory === 'Other Service Issue'
      },
      conditionalRequired: {
        condition: (data) => data.complaintCategory === 'Other Service Issue',
        message: 'Please specify the custom complaint category when "Other Service Issue" is selected'
      },
      hint: 'Provide a specific description of the complaint type when "Other Service Issue" is selected.'
    },
    {
      name: 'complainantDetails', // ← CRITICAL: Was 'complainantType' - now matches template
      type: 'text',
      label: 'Complainant Details',
      header: 'Complainant Details',
      placeholder: 'Name and contact details of person making complaint',
      required: true,
      validationMessage: 'Please provide complainant details',
      hint: 'Enter the name and relevant contact information of the person making the complaint.'
    },
    {
      name: 'complaintDescription',
      type: 'textarea',
      label: 'Complaint Details',
      header: 'Description',
      placeholder: 'Describe the service complaint in detail...',
      required: true,
      validationMessage: 'Please provide detailed information about the service complaint',
      hint: (
        <div>
          <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Document the complaint including:</p>
          <ul style={{ margin: 0, paddingLeft: '1rem' }}>
            <li>Specific nature of the complaint</li>
            <li>What the patron was dissatisfied with</li>
            <li>Any specific staff members mentioned</li>
            <li>Patron's desired resolution or expectation</li>
            <li>Severity and impact of the issue</li>
            <li>Any witnesses to the situation</li>
          </ul>
        </div>
      )
    },
    {
      name: 'complaintSeverity', // ← CRITICAL: Was 'severityLevel' - now matches template
      type: 'dropdown',
      label: 'Complaint Severity',
      header: 'Severity',
      placeholder: 'Assess the severity of this complaint',
      options: [
        { value: 'Minor - Small inconvenience', label: 'Minor - Small inconvenience' },
        { value: 'Moderate - Noticeable impact', label: 'Moderate - Noticeable impact' },
        { value: 'Significant - Major dissatisfaction', label: 'Significant - Major dissatisfaction' },
        { value: 'Severe - Serious service failure', label: 'Severe - Serious service failure' }
      ],
      required: true,
      validationMessage: 'Please assess the severity level of this service complaint',
      hint: 'Evaluate the severity based on the impact on the patron experience and potential reputational consequences.'
    },
    {
      name: 'immediateResponse',
      type: 'textarea',
      label: 'Immediate Response/Actions Taken',
      header: 'Response',
      placeholder: 'Describe how the complaint was addressed immediately...',
      required: true,
      validationMessage: 'Please describe the immediate response to this service complaint',
      hint: (
        <div>
          <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Document immediate response including:</p>
          <ul style={{ margin: 0, paddingLeft: '1rem' }}>
            <li>How the complainant was acknowledged</li>
            <li>Immediate steps taken to address the issue</li>
            <li>Compensation or goodwill gestures offered</li>
            <li>Staff members involved in resolution</li>
            <li>Escalation to supervisors or management</li>
            <li>Follow-up commitments made to patron</li>
          </ul>
        </div>
      )
    },
    {
      name: 'followUpRequired', // ← ADDED: Required by template
      type: 'checkbox',
      label: 'Follow-up action required?',
      header: 'Follow-Up Required',
      hint: 'Check this box if additional follow-up actions are needed to fully resolve this complaint.',
      displayTransform: (value) => value ? 'Yes' : 'No'
    },
    {
      name: 'followUpDetails', // ← ADDED: Required by template
      type: 'textarea',
      label: 'Follow-up Details',
      header: 'Follow-Up Details',
      placeholder: 'Describe follow-up actions planned or required...',
      hideUntil: {
        condition: (data) => data.followUpRequired
      },
      conditionalRequired: {
        condition: (data) => data.followUpRequired,
        message: 'Please describe the follow-up actions required'
      },
      hint: 'Detail any follow-up actions needed such as additional training, policy reviews, or customer contact.'
    }
    // ← REMOVED these fields (not in template):
    // - location
    // - resolutionStatus
  ];

  return (
    <ModernDataTable
      suppressTitle={true}
      data={serviceComplaintItems}
      setData={setServiceComplaintItems}
      fields={complaintFields}
      addButtonText="Add Service Complaint"
      emptyMessage="No service complaints added yet."
      truncateLines={2}
      defaultDateTime={defaultDateTime}
    />
  );
};

export default Step11;